const wordsPerMin = 225;
export const calculateEstimatedReadTime = (content) => {
    const words = (content?.replace(/<\/?[^>]+(>|$)/g, "").split(' ').length || 0);
    return Math.round(Math.max(words/wordsPerMin, 1));
};